import React, { useEffect, useState } from 'react';
import InputMask from 'react-input-mask';
import ReactSelect from 'react-select';
import { useEntityCrud } from '../../hooks/useEntityCrud';
import DatePicker from '@hassanmojab/react-modern-calendar-datepicker';

const RankBaseQuestion = () => {

    const convertToGregorian = date => date.year.toString() + (date.month > 9 ? date.month.toString() : ('0' + date.month)) + (date.day > 9 ? date.day.toString() : ('0' + date.day))

    const { readData: getReports } = useEntityCrud('Report/RankBaseQuestion');
    const { readData: getGuilds } = useEntityCrud('Guild/GetAllGuilds');
    const { readData: getBusiness } = useEntityCrud('Business/GetAllBusiness');
    const { readData: getOpinions } = useEntityCrud('Opinions/getAll');
    const [isSearched, setIsSearched] = useState(false);
    const [opinion, setOpinion] = useState(0);
    const [guild, setGuild] = useState(0);
    const [business, setBusiness] = useState(0);
    const [guilds, setGuilds] = useState([]);
    const [businesses, setBusinesses] = useState([]);
    const [opinions, setOpinions] = useState([]);
    const [rows, setRows] = useState([]);
    const [businessesRows, setBusinessesRows] = useState({});
    const [questions, setQuestions] = useState([]);
    const [excelPath, setExcelPath] = useState('');
    const [isAdvanced, setIsAdvanced] = useState(false);
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [cityId, setCityId] = useState(0);
    const [provinceId, setProvinceId] = useState(0);
    const { readGetDataById: getProvinces } = useEntityCrud('Info/GetProvinces');
    const { readGetDataById: getCities } = useEntityCrud(`Info/GetCities?provinceId=${provinceId}`);
    const [provinces, setProvinces] = useState([]);
    const [cities, setCities] = useState([]);
    const [isLoading, setLoading] = useState(false);
    const [showItem, setShowItem] = useState(true);

    const [branchId, setBranchId] = useState([]);
    const [branchs, setBranchs] = useState([]);
    const { readData: getBranchs } = useEntityCrud('Branch/GetAllBranchs');

    let userData = localStorage.getItem('user') != null ? JSON.parse(localStorage.getItem('user')).roleId : {};



    useEffect(() => {
        getBranchs().then(({ data }) => {
            let branchs = [];
            if (data.status)
                data.result.map(item => {
                    if (item.isActive)
                        branchs.push({
                            label: item.title,
                            value: item.id
                        });
                })
            setBranchs(branchs);
        })

        getGuilds().then(({ data }) => {
            let guildsArr = [];
            if (data.status)
                data.result.map(item => {
                    if(item.isActive)
                        guildsArr.push({
                            label: item.title,
                            value: item.id
                        });
                })
            setGuilds(guildsArr);
        })
        getBusiness().then(({ data }) => {
            let businesses = [];
            if (data.status)
                data.result.map(item => {
                    // if (item.isActive) {
                        // if (!(businesses?.find(it => it.label === item.title))) {
                            businesses.push({
                                label: item.title,
                                value: item.id
                            });
                        // }
                    // }
                })
            setBusinesses(businesses);
            if (userData === 3) {
                setBusiness(businesses.map(item => item)[0].value)
            }
        })
        getOpinions().then(({ data }) => {
            let opinionsArr = [];
            if (data.status)
                data.result.map(item => {
                    opinionsArr.push({
                        label: item.title,
                        value: item.id
                    });
                })
            setOpinions(opinionsArr);
        })
        getProvinces().then(({ data }) => {
            let getProvinces = [];
            data.result.map(item => getProvinces.push({
                label: item.title,
                value: item.id
            }))
            setProvinces(getProvinces);
        })
    }, [])

    useEffect(() => {
        if (provinceId != 0)
            getCities().then(({ data }) => {
                if (data.status) {
                    let getCities = [];
                    data.result.map(item => getCities.push({
                        label: item.title,
                        value: item.id
                    }))
                    setCities(getCities);
                }
            });
    }, [provinceId])


    const getReportsData = () => {


        setIsAdvanced(true);
        setLoading(true);
        setShowItem(false);
        const postedData = {
            p_opinion_id: opinion || 0,
            p_guild_id: guild || 0,
            p_business_id: business || 0,
            p_cityid: cityId,
            branchId: branchId
        };
        if(fromDate)
            postedData.p_fromdate = convertToGregorian(fromDate)
        if(toDate)
            postedData.p_todate = convertToGregorian(toDate)
        getReports(postedData).then(({ data }) => {

            setLoading(false)
            setShowItem(true);
            if (data.status && data.result) {
                let getQuestions = [];
                let getBusinesses = {};
                data.result.v_result.map(item => {
                    if (!getQuestions.includes(item.q_title) && item.q_title != null)
                        getQuestions.push(item.q_title);
                    if (!getBusinesses[item.bu_title])
                        getBusinesses[item.bu_title] = { points: [], cntUse: item.cnt_use };
                    getBusinesses[item.bu_title].points.push(item.avg_point);
                })
                setExcelPath(data.result.excelPath);
                setQuestions(getQuestions);
                setBusinessesRows(getBusinesses);
                setRows(data.result.v_result);


                console.log(questions, getQuestions);

            } else
                setRows([]);
        }).finally(() => {
            setIsSearched(true);
        });
    }

    const downloadExcelFile = () => {
        let a = window.document.createElement('a');
        a.setAttribute('href', excelPath);
        a.setAttribute('download', '');
        window.document.body.appendChild(a);
        a.click();
        window.document.body.removeChild(a);
    }

    const sortReport = question => {
        const oldBusinessRows = { ...businessesRows };
        let result = Object.keys(oldBusinessRows).sort((a, b) => {
            return oldBusinessRows[b].points[question] - oldBusinessRows[a].points[question]
        })
        const final = {};
        result.map(item => {
            final[item] = oldBusinessRows[item]
        })
        setBusinessesRows(final);
    }

    const advancedSearch = e => {
        e.preventDefault();
        getReportsData();
        setIsAdvanced(true);
    }

    const resetAdvancedSearch = e => {


        e.preventDefault();
        setIsAdvanced(false);
        setRows([]);
        setIsSearched(false)

        setOpinion(0)
        setBranchId([])
        setBusiness(0)
        setGuild(0)


    }


    return (
        <div className="row">

            {userData !== 3 && <div className="col-md-2">
                <div className="form-group">
                    {guild ? <i className="fe fe-x clear-select-btn" onClick={e => setGuild(0)}></i> : ''}
                    <label>صنف</label>
                    <div className="position-relative" style={{zIndex: 2}}>
                        <ReactSelect noOptionsMessage={e => 'یافت نشد'} placeholder="انتخاب کنید" options={guilds} value={guilds.filter(b => b.value == guild)} onChange={e => setGuild(e.value)} />
                    </div>
                </div>
            </div>}

            <div className="col-md-2">
                <div className="form-group">
                    {opinion ? <i className="fe fe-x clear-select-btn" onClick={e => setOpinion(0)}></i> : ''}
                    <label>نظرسنجی</label>
                    <div className="position-relative" style={{zIndex: 2}}>
                        <ReactSelect noOptionsMessage={e => 'یافت نشد'} placeholder="انتخاب کنید" options={opinions} value={opinions.filter(b => b.value == opinion)} onChange={e => setOpinion(e.value)} />
                    </div>
                </div>
            </div>

            <div className="col-md-2">
                <div className="form-group">
                    {business ? <i className="fe fe-x clear-select-btn" onClick={e => setBusiness(0)}></i> : ''}
                    <label>کسب و کار</label>
                    <ReactSelect noOptionsMessage={e => 'یافت نشد'} placeholder="انتخاب کنید" options={businesses} value={businesses.filter(b => b.value == business)} onChange={e => setBusiness(e.value)} />
                </div>
            </div>


            {userData !== 3 && <div className="col-md-2">
                <div className="form-group">
                    <label>شرکت زیر مجموعه</label>
                    <ReactSelect noOptionsMessage={e => 'یافت نشد'} placeholder="انتخاب کنید" options={branchs} isMulti={true} value={branchs.filter(item => branchId.includes(item.value))} onChange={e => setBranchId([...e.map(i => i.value)])} />
                </div>
            </div>}

            <div className="col-md-2">
                <div className="form-group">
                    <label>استان</label>
                    <ReactSelect noOptionsMessage={e => 'یافت نشد'} placeholder="انتخاب کنید" options={provinces} value={provinces.filter(item => item.value == provinceId)} onChange={e => setProvinceId(e.value)} />
                </div>
            </div>
            <div className="col-md-2">
                <div className="form-group">
                    <label>شهر</label>
                    <ReactSelect noOptionsMessage={e => 'یافت نشد'} disabled={!provinces.length} placeholder="انتخاب کنید" isDisabled={!cities.length} options={cities} value={cities.filter(item => item.value == cityId)} onChange={e => setCityId(e.value)} />
                </div>
            </div>
            <div className="col-md-2">
                <div className="form-group">
                    <label>از تاریخ</label>
                    {fromDate && <i class="fe fe-x clear-select-btn" onClick={() => setFromDate(null)} style={{left: 25}}></i>}
                    <div className="position-relative" style={{zIndex: 1}}>
                        <DatePicker
                            name="fromDate"
                            required
                            locale="fa"
                            shouldHighlightWeekends
                            value={fromDate}
                            onChange={setFromDate}
                            className="form-control"
                            inputPlaceholder='تاریخ  را انتخاب کنید ...'
                        />
                    </div>
                </div>
            </div>
            <div className="col-md-2">
                <div className="form-group">
                    <label>از تاریخ</label>
                    {toDate && <i class="fe fe-x clear-select-btn" onClick={() => setToDate(null)} style={{left: 25}}></i>}
                    <div className="position-relative" style={{zIndex: 1}}>
                        <DatePicker
                            name="toDate"
                            required
                            locale="fa"
                            shouldHighlightWeekends
                            value={toDate}
                            onChange={setToDate}
                            className="form-control"
                            inputPlaceholder='تاریخ  را انتخاب کنید ...'
                        />
                    </div>
                </div>
            </div>

            {/*           <div className="col-md-1" style={{ marginTop: 31, textAlign: "center" }}>
                <button className="btn btn-primary" onClick={advancedSearch}>جستجو</button>
            </div>
            {isAdvanced && <div className="col-md-1" style={{ marginTop: 31 }}>
                <button className="btn btn-danger btn-block" onClick={resetAdvancedSearch}>حذف فیلتر</button>
            </div>} */}


            <div className="py-2 col-md-2" style={{ marginTop: 25, textAlign: "center" }}>
                {showItem && <> <button className="btn btn-primary" onClick={advancedSearch}>جستجو</button>
                    {isAdvanced &&
                        <button className="btn btn-danger mx-2" onClick={resetAdvancedSearch}>حذف فیلتر</button>
                    }
                </>
                }
            </div>


            {isLoading ?
                <div className="lds-facebook mt-4">
                    <div></div>
                    <div></div>
                    <div></div>
                </div > :

                <>
                    {rows.length ? <div className="col-md-12 mt-3">
                        <div className="table-responsive bg-white p-4" style={{ borderRadius: 7 }}>
                            <table className="table custom-table-style table-bordered table-hover mb4">
                                <thead className="table-primary text-center">
                                    <tr>
                                        <th>کسب و کار</th>
                                        {questions.map((question, index) => (
                                            <th style={{ cursor: 'pointer' }} key={question} onClick={() => sortReport(index)}>{question}</th>
                                        ))}
                                        <th>تعداد شرکت کنندگان</th>
                                    </tr>
                                </thead>
                                <tbody className="text-center">
                                    {Object.keys(businessesRows).map((row, index) => (
                                        <tr key={index}>
                                            <td>{row}</td>
                                            {questions.map((question, questionIndex) => (
                                                <td key={question + questionIndex}>{businessesRows[row].points[questionIndex]}</td>
                                            ))}
                                            <td>{businessesRows[row].cntUse}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <button className="btn btn-success" onClick={downloadExcelFile}>دریافت خروجی اکسل</button>
                        </div>
                    </div> : isSearched ? <div className="col-md-12 mt-2"><div className="alert alert-primary"><p>داده ای جهت نمایش یافت نشد</p></div></div> : <div className="col-md-12 mt-2"><div className="alert alert-info"><p>جهت دریافت اطلاعات پس از اعمال فیلتر های مورد نظر بر روی جستجو کلیک کنید</p></div></div>
                    }
                </>
            }

        </div >
    )
}

export default RankBaseQuestion;
